import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./home/home";
import ImageViewer from "./ImageViewer";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/files/:id" element={<ImageViewer />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;